import React, { PropsWithChildren } from "react";
import { cn } from "helpers/style";
import { capitalize } from "helpers/text";
import styles from "./Badge.module.scss";

export type BadgeProps = Partial<{
  disabled: boolean;
  type: Entity.BadgeType;
  color:
    | "red"
    | "blue"
    | "white"
    | "purple"
    | "orange"
    | "violet"
    | "lightBlue2"
    | "green"
    | "darkYellow"
    | "lightGray"
    | string;
  big: boolean;
  withImage: boolean;
  className?: string;
}>;

type Props = PropsWithChildren<BadgeProps>;

const Badge: React.FC<Props> = ({
  disabled,
  type,
  color,
  children,
  big,
  withImage,
  className,
}: Props) => {
  return (
    <div
      className={cn([
        styles.badge,
        color && !color.startsWith("#") && styles[`badge${capitalize(color)}`],
        disabled && styles.badgeDisabled,
        type && styles[`badge${capitalize(type)}`],
        big && styles.badgeBig,
        withImage && styles.badgeWithImage,
        className,
      ])}
      style={color?.startsWith("#") ? { background: color } : {}}
    >
      {children}
    </div>
  );
};

export default Badge;
